import axios from 'axios';

const createApi = (version = 'v1') => {
    return axios.create({
        baseURL: `${process.env.NEXT_PUBLIC_API_BASE_URL}/${version}`,
        headers: {
            'Content-Type': 'application/json',
        },
    });
};

const api = createApi('v1');
const apiV2 = createApi('v2');
const apiV3 = createApi('v3');
const apiV4 = createApi('v4');

const acervoApi = axios.create({
    baseURL: process.env.NEXT_PUBLIC_API_ACERVO_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

export { api, apiV2, apiV3, apiV4, acervoApi };